/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bzHsBkgGqqFqgQ8Ug5BFVy
import { createUseStyleTokens } from "@plasmicapp/react-web";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectModule
import "./plasmic.css"; // plasmic-import: bzHsBkgGqqFqgQ8Ug5BFVy/projectcss
import "../one_platform/plasmic.css"; // plasmic-import: 9Kput4gSSeupaVq7b57ZAu/projectcss
import "../antd_5_hostless/plasmic.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import "../plasmic_rich_components/plasmic.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss

const data = {
  base: `${"plasmic_tokens_bzHsBkgGqqFqgQ8Ug5BFVy"} ${"plasmic_tokens_9Kput4gSSeupaVq7b57ZAu"} ${"plasmic_tokens_ohDidvG9XsCeFumugENU3J"} ${"plasmic_tokens_jkU633o1Cz7HrJdwdxhVHk"}`,
  varianted: []
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);
